// minLength / maxLength = national significant number length range (digits
// after the dial code, excluding any leading trunk "0"). For most countries
// this is a fixed length (minLength === maxLength). For numbering plans that
// genuinely vary (e.g. Germany, Austria, Indonesia, Sweden, Finland, New
// Zealand, Malaysia, several small Pacific island nations), a real range is
// given. These ranges reflect commonly issued (mostly mobile) numbers rather
// than the full theoretical numbering-plan range, verify against official
// docs if you need airtight validation for a specific country.
const COUNTRY_CODES = [
    { country: "Afghanistan", iso2: "AF", dialCode: "+93", minLength: 9, maxLength: 9 },
    { country: "Albania", iso2: "AL", dialCode: "+355", minLength: 9, maxLength: 9 },
    { country: "Algeria", iso2: "DZ", dialCode: "+213", minLength: 9, maxLength: 9 },
    { country: "Andorra", iso2: "AD", dialCode: "+376", minLength: 6, maxLength: 6 },
    { country: "Angola", iso2: "AO", dialCode: "+244", minLength: 9, maxLength: 9 },
    { country: "Antigua and Barbuda", iso2: "AG", dialCode: "+1268", minLength: 10, maxLength: 10 },
    { country: "Argentina", iso2: "AR", dialCode: "+54", minLength: 10, maxLength: 11 },
    { country: "Armenia", iso2: "AM", dialCode: "+374", minLength: 8, maxLength: 8 },
    { country: "Australia", iso2: "AU", dialCode: "+61", minLength: 9, maxLength: 9 },
    { country: "Austria", iso2: "AT", dialCode: "+43", minLength: 7, maxLength: 13 },
    { country: "Azerbaijan", iso2: "AZ", dialCode: "+994", minLength: 9, maxLength: 9 },
    { country: "Bahamas", iso2: "BS", dialCode: "+1242", minLength: 10, maxLength: 10 },
    { country: "Bahrain", iso2: "BH", dialCode: "+973", minLength: 8, maxLength: 8 },
    { country: "Bangladesh", iso2: "BD", dialCode: "+880", minLength: 10, maxLength: 10 },
    { country: "Barbados", iso2: "BB", dialCode: "+1246", minLength: 10, maxLength: 10 },
    { country: "Belarus", iso2: "BY", dialCode: "+375", minLength: 9, maxLength: 9 },
    { country: "Belgium", iso2: "BE", dialCode: "+32", minLength: 8, maxLength: 9 },
    { country: "Belize", iso2: "BZ", dialCode: "+501", minLength: 7, maxLength: 7 },
    { country: "Benin", iso2: "BJ", dialCode: "+229", minLength: 8, maxLength: 8 },
    { country: "Bhutan", iso2: "BT", dialCode: "+975", minLength: 6, maxLength: 8 },
    { country: "Bolivia", iso2: "BO", dialCode: "+591", minLength: 8, maxLength: 8 },
    { country: "Bosnia and Herzegovina", iso2: "BA", dialCode: "+387", minLength: 8, maxLength: 8 },
    { country: "Botswana", iso2: "BW", dialCode: "+267", minLength: 7, maxLength: 8 },
    { country: "Brazil", iso2: "BR", dialCode: "+55", minLength: 10, maxLength: 11 },
    { country: "Brunei", iso2: "BN", dialCode: "+673", minLength: 7, maxLength: 7 },
    { country: "Bulgaria", iso2: "BG", dialCode: "+359", minLength: 8, maxLength: 9 },
    { country: "Burkina Faso", iso2: "BF", dialCode: "+226", minLength: 8, maxLength: 8 },
    { country: "Burundi", iso2: "BI", dialCode: "+257", minLength: 8, maxLength: 8 },
    { country: "Cabo Verde", iso2: "CV", dialCode: "+238", minLength: 7, maxLength: 7 },
    { country: "Cambodia", iso2: "KH", dialCode: "+855", minLength: 8, maxLength: 9 },
    { country: "Cameroon", iso2: "CM", dialCode: "+237", minLength: 9, maxLength: 9 },
    { country: "Canada", iso2: "CA", dialCode: "+1", minLength: 10, maxLength: 10 },
    { country: "Central African Republic", iso2: "CF", dialCode: "+236", minLength: 8, maxLength: 8 },
    { country: "Chad", iso2: "TD", dialCode: "+235", minLength: 8, maxLength: 8 },
    { country: "Chile", iso2: "CL", dialCode: "+56", minLength: 9, maxLength: 9 },
    { country: "China", iso2: "CN", dialCode: "+86", minLength: 11, maxLength: 11 },
    { country: "Colombia", iso2: "CO", dialCode: "+57", minLength: 10, maxLength: 10 },
    { country: "Comoros", iso2: "KM", dialCode: "+269", minLength: 7, maxLength: 7 },
    { country: "Costa Rica", iso2: "CR", dialCode: "+506", minLength: 8, maxLength: 8 },
    { country: "Côte d'Ivoire", iso2: "CI", dialCode: "+225", minLength: 10, maxLength: 10 },
    { country: "Croatia", iso2: "HR", dialCode: "+385", minLength: 8, maxLength: 9 },
    { country: "Cuba", iso2: "CU", dialCode: "+53", minLength: 6, maxLength: 8 },
    { country: "Cyprus", iso2: "CY", dialCode: "+357", minLength: 8, maxLength: 8 },
    { country: "Czechia", iso2: "CZ", dialCode: "+420", minLength: 9, maxLength: 9 },
    { country: "Democratic Republic of the Congo", iso2: "CD", dialCode: "+243", minLength: 9, maxLength: 9 },
    { country: "Denmark", iso2: "DK", dialCode: "+45", minLength: 8, maxLength: 8 },
    { country: "Djibouti", iso2: "DJ", dialCode: "+253", minLength: 6, maxLength: 6 },
    { country: "Dominica", iso2: "DM", dialCode: "+1767", minLength: 10, maxLength: 10 },
    { country: "Dominican Republic", iso2: "DO", dialCode: "+1", minLength: 10, maxLength: 10 },
    { country: "Ecuador", iso2: "EC", dialCode: "+593", minLength: 8, maxLength: 9 },
    { country: "Egypt", iso2: "EG", dialCode: "+20", minLength: 8, maxLength: 10 },
    { country: "El Salvador", iso2: "SV", dialCode: "+503", minLength: 8, maxLength: 8 },
    { country: "Equatorial Guinea", iso2: "GQ", dialCode: "+240", minLength: 9, maxLength: 9 },
    { country: "Eritrea", iso2: "ER", dialCode: "+291", minLength: 6, maxLength: 7 },
    { country: "Estonia", iso2: "EE", dialCode: "+372", minLength: 7, maxLength: 8 },
    { country: "Eswatini", iso2: "SZ", dialCode: "+268", minLength: 8, maxLength: 8 },
    { country: "Ethiopia", iso2: "ET", dialCode: "+251", minLength: 9, maxLength: 9 },
    { country: "Fiji", iso2: "FJ", dialCode: "+679", minLength: 7, maxLength: 7 },
    { country: "Finland", iso2: "FI", dialCode: "+358", minLength: 8, maxLength: 10 },
    { country: "France", iso2: "FR", dialCode: "+33", minLength: 9, maxLength: 9 },
    { country: "Gabon", iso2: "GA", dialCode: "+241", minLength: 8, maxLength: 8 },
    { country: "Gambia", iso2: "GM", dialCode: "+220", minLength: 7, maxLength: 7 },
    { country: "Georgia", iso2: "GE", dialCode: "+995", minLength: 9, maxLength: 9 },
    { country: "Germany", iso2: "DE", dialCode: "+49", minLength: 7, maxLength: 11 },
    { country: "Ghana", iso2: "GH", dialCode: "+233", minLength: 9, maxLength: 9 },
    { country: "Greece", iso2: "GR", dialCode: "+30", minLength: 10, maxLength: 10 },
    { country: "Grenada", iso2: "GD", dialCode: "+1473", minLength: 10, maxLength: 10 },
    { country: "Guatemala", iso2: "GT", dialCode: "+502", minLength: 8, maxLength: 8 },
    { country: "Guinea", iso2: "GN", dialCode: "+224", minLength: 9, maxLength: 9 },
    { country: "Guinea-Bissau", iso2: "GW", dialCode: "+245", minLength: 7, maxLength: 7 },
    { country: "Guyana", iso2: "GY", dialCode: "+592", minLength: 7, maxLength: 7 },
    { country: "Haiti", iso2: "HT", dialCode: "+509", minLength: 8, maxLength: 8 },
    { country: "Honduras", iso2: "HN", dialCode: "+504", minLength: 8, maxLength: 8 },
    { country: "Hungary", iso2: "HU", dialCode: "+36", minLength: 9, maxLength: 9 },
    { country: "Iceland", iso2: "IS", dialCode: "+354", minLength: 7, maxLength: 7 },
    { country: "India", iso2: "IN", dialCode: "+91", minLength: 10, maxLength: 10 },
    { country: "Indonesia", iso2: "ID", dialCode: "+62", minLength: 8, maxLength: 11 },
    { country: "Iran", iso2: "IR", dialCode: "+98", minLength: 10, maxLength: 10 },
    { country: "Iraq", iso2: "IQ", dialCode: "+964", minLength: 9, maxLength: 10 },
    { country: "Ireland", iso2: "IE", dialCode: "+353", minLength: 9, maxLength: 9 },
    { country: "Israel", iso2: "IL", dialCode: "+972", minLength: 8, maxLength: 9 },
    { country: "Italy", iso2: "IT", dialCode: "+39", minLength: 9, maxLength: 10 },
    { country: "Jamaica", iso2: "JM", dialCode: "+1876", minLength: 10, maxLength: 10 },
    { country: "Japan", iso2: "JP", dialCode: "+81", minLength: 10, maxLength: 10 },
    { country: "Jordan", iso2: "JO", dialCode: "+962", minLength: 9, maxLength: 9 },
    { country: "Kazakhstan", iso2: "KZ", dialCode: "+7", minLength: 10, maxLength: 10 },
    { country: "Kenya", iso2: "KE", dialCode: "+254", minLength: 9, maxLength: 9 },
    { country: "Kiribati", iso2: "KI", dialCode: "+686", minLength: 5, maxLength: 8 },
    { country: "Kuwait", iso2: "KW", dialCode: "+965", minLength: 8, maxLength: 8 },
    { country: "Kyrgyzstan", iso2: "KG", dialCode: "+996", minLength: 9, maxLength: 9 },
    { country: "Laos", iso2: "LA", dialCode: "+856", minLength: 8, maxLength: 10 },
    { country: "Latvia", iso2: "LV", dialCode: "+371", minLength: 8, maxLength: 8 },
    { country: "Lebanon", iso2: "LB", dialCode: "+961", minLength: 7, maxLength: 8 },
    { country: "Lesotho", iso2: "LS", dialCode: "+266", minLength: 8, maxLength: 8 },
    { country: "Liberia", iso2: "LR", dialCode: "+231", minLength: 7, maxLength: 8 },
    { country: "Libya", iso2: "LY", dialCode: "+218", minLength: 9, maxLength: 9 },
    { country: "Liechtenstein", iso2: "LI", dialCode: "+423", minLength: 7, maxLength: 7 },
    { country: "Lithuania", iso2: "LT", dialCode: "+370", minLength: 8, maxLength: 8 },
    { country: "Luxembourg", iso2: "LU", dialCode: "+352", minLength: 9, maxLength: 9 },
    { country: "Madagascar", iso2: "MG", dialCode: "+261", minLength: 9, maxLength: 9 },
    { country: "Malawi", iso2: "MW", dialCode: "+265", minLength: 9, maxLength: 9 },
    { country: "Malaysia", iso2: "MY", dialCode: "+60", minLength: 8, maxLength: 10 },
    { country: "Maldives", iso2: "MV", dialCode: "+960", minLength: 7, maxLength: 7 },
    { country: "Mali", iso2: "ML", dialCode: "+223", minLength: 8, maxLength: 8 },
    { country: "Malta", iso2: "MT", dialCode: "+356", minLength: 8, maxLength: 8 },
    { country: "Marshall Islands", iso2: "MH", dialCode: "+692", minLength: 7, maxLength: 7 },
    { country: "Mauritania", iso2: "MR", dialCode: "+222", minLength: 8, maxLength: 8 },
    { country: "Mauritius", iso2: "MU", dialCode: "+230", minLength: 7, maxLength: 8 },
    { country: "Mexico", iso2: "MX", dialCode: "+52", minLength: 10, maxLength: 10 },
    { country: "Micronesia (Federated States of)", iso2: "FM", dialCode: "+691", minLength: 7, maxLength: 7 },
    { country: "Moldova", iso2: "MD", dialCode: "+373", minLength: 8, maxLength: 8 },
    { country: "Monaco", iso2: "MC", dialCode: "+377", minLength: 8, maxLength: 9 },
    { country: "Mongolia", iso2: "MN", dialCode: "+976", minLength: 8, maxLength: 8 },
    { country: "Montenegro", iso2: "ME", dialCode: "+382", minLength: 8, maxLength: 8 },
    { country: "Morocco", iso2: "MA", dialCode: "+212", minLength: 9, maxLength: 9 },
    { country: "Mozambique", iso2: "MZ", dialCode: "+258", minLength: 9, maxLength: 9 },
    { country: "Myanmar", iso2: "MM", dialCode: "+95", minLength: 7, maxLength: 10 },
    { country: "Namibia", iso2: "NA", dialCode: "+264", minLength: 9, maxLength: 9 },
    { country: "Nauru", iso2: "NR", dialCode: "+674", minLength: 7, maxLength: 7 },
    { country: "Nepal", iso2: "NP", dialCode: "+977", minLength: 10, maxLength: 10 },
    { country: "Netherlands", iso2: "NL", dialCode: "+31", minLength: 9, maxLength: 9 },
    { country: "New Zealand", iso2: "NZ", dialCode: "+64", minLength: 8, maxLength: 10 },
    { country: "Nicaragua", iso2: "NI", dialCode: "+505", minLength: 8, maxLength: 8 },
    { country: "Niger", iso2: "NE", dialCode: "+227", minLength: 8, maxLength: 8 },
    { country: "Nigeria", iso2: "NG", dialCode: "+234", minLength: 10, maxLength: 10 },
    { country: "North Korea", iso2: "KP", dialCode: "+850", minLength: 8, maxLength: 10 },
    { country: "North Macedonia", iso2: "MK", dialCode: "+389", minLength: 8, maxLength: 8 },
    { country: "Norway", iso2: "NO", dialCode: "+47", minLength: 8, maxLength: 8 },
    { country: "Oman", iso2: "OM", dialCode: "+968", minLength: 8, maxLength: 8 },
    { country: "Pakistan", iso2: "PK", dialCode: "+92", minLength: 10, maxLength: 10 },
    { country: "Palau", iso2: "PW", dialCode: "+680", minLength: 7, maxLength: 7 },
    { country: "Palestine", iso2: "PS", dialCode: "+970", minLength: 9, maxLength: 9 },
    { country: "Panama", iso2: "PA", dialCode: "+507", minLength: 8, maxLength: 8 },
    { country: "Papua New Guinea", iso2: "PG", dialCode: "+675", minLength: 8, maxLength: 8 },
    { country: "Paraguay", iso2: "PY", dialCode: "+595", minLength: 9, maxLength: 9 },
    { country: "Peru", iso2: "PE", dialCode: "+51", minLength: 9, maxLength: 9 },
    { country: "Philippines", iso2: "PH", dialCode: "+63", minLength: 10, maxLength: 10 },
    { country: "Poland", iso2: "PL", dialCode: "+48", minLength: 9, maxLength: 9 },
    { country: "Portugal", iso2: "PT", dialCode: "+351", minLength: 9, maxLength: 9 },
    { country: "Qatar", iso2: "QA", dialCode: "+974", minLength: 8, maxLength: 8 },
    { country: "Republic of the Congo", iso2: "CG", dialCode: "+242", minLength: 9, maxLength: 9 },
    { country: "Romania", iso2: "RO", dialCode: "+40", minLength: 9, maxLength: 9 },
    { country: "Russia", iso2: "RU", dialCode: "+7", minLength: 10, maxLength: 10 },
    { country: "Rwanda", iso2: "RW", dialCode: "+250", minLength: 9, maxLength: 9 },
    { country: "Saint Kitts and Nevis", iso2: "KN", dialCode: "+1869", minLength: 10, maxLength: 10 },
    { country: "Saint Lucia", iso2: "LC", dialCode: "+1758", minLength: 10, maxLength: 10 },
    { country: "Saint Vincent and the Grenadines", iso2: "VC", dialCode: "+1784", minLength: 10, maxLength: 10 },
    { country: "Samoa", iso2: "WS", dialCode: "+685", minLength: 5, maxLength: 7 },
    { country: "San Marino", iso2: "SM", dialCode: "+378", minLength: 6, maxLength: 10 },
    { country: "São Tomé and Príncipe", iso2: "ST", dialCode: "+239", minLength: 7, maxLength: 7 },
    { country: "Saudi Arabia", iso2: "SA", dialCode: "+966", minLength: 9, maxLength: 9 },
    { country: "Senegal", iso2: "SN", dialCode: "+221", minLength: 9, maxLength: 9 },
    { country: "Serbia", iso2: "RS", dialCode: "+381", minLength: 8, maxLength: 9 },
    { country: "Seychelles", iso2: "SC", dialCode: "+248", minLength: 7, maxLength: 7 },
    { country: "Sierra Leone", iso2: "SL", dialCode: "+232", minLength: 8, maxLength: 8 },
    { country: "Singapore", iso2: "SG", dialCode: "+65", minLength: 8, maxLength: 8 },
    { country: "Slovakia", iso2: "SK", dialCode: "+421", minLength: 9, maxLength: 9 },
    { country: "Slovenia", iso2: "SI", dialCode: "+386", minLength: 8, maxLength: 8 },
    { country: "Solomon Islands", iso2: "SB", dialCode: "+677", minLength: 5, maxLength: 7 },
    { country: "Somalia", iso2: "SO", dialCode: "+252", minLength: 6, maxLength: 8 },
    { country: "South Africa", iso2: "ZA", dialCode: "+27", minLength: 9, maxLength: 9 },
    { country: "South Korea", iso2: "KR", dialCode: "+82", minLength: 9, maxLength: 10 },
    { country: "South Sudan", iso2: "SS", dialCode: "+211", minLength: 9, maxLength: 9 },
    { country: "Spain", iso2: "ES", dialCode: "+34", minLength: 9, maxLength: 9 },
    { country: "Sri Lanka", iso2: "LK", dialCode: "+94", minLength: 9, maxLength: 9 },
    { country: "Sudan", iso2: "SD", dialCode: "+249", minLength: 9, maxLength: 9 },
    { country: "Suriname", iso2: "SR", dialCode: "+597", minLength: 6, maxLength: 7 },
    { country: "Sweden", iso2: "SE", dialCode: "+46", minLength: 7, maxLength: 9 },
    { country: "Switzerland", iso2: "CH", dialCode: "+41", minLength: 9, maxLength: 9 },
    { country: "Syria", iso2: "SY", dialCode: "+963", minLength: 8, maxLength: 9 },
    { country: "Tajikistan", iso2: "TJ", dialCode: "+992", minLength: 9, maxLength: 9 },
    { country: "Tanzania", iso2: "TZ", dialCode: "+255", minLength: 9, maxLength: 9 },
    { country: "Thailand", iso2: "TH", dialCode: "+66", minLength: 8, maxLength: 9 },
    { country: "Timor-Leste", iso2: "TL", dialCode: "+670", minLength: 7, maxLength: 8 },
    { country: "Togo", iso2: "TG", dialCode: "+228", minLength: 8, maxLength: 8 },
    { country: "Tonga", iso2: "TO", dialCode: "+676", minLength: 5, maxLength: 7 },
    { country: "Trinidad and Tobago", iso2: "TT", dialCode: "+1868", minLength: 10, maxLength: 10 },
    { country: "Tunisia", iso2: "TN", dialCode: "+216", minLength: 8, maxLength: 8 },
    { country: "Türkiye", iso2: "TR", dialCode: "+90", minLength: 10, maxLength: 10 },
    { country: "Turkmenistan", iso2: "TM", dialCode: "+993", minLength: 8, maxLength: 8 },
    { country: "Tuvalu", iso2: "TV", dialCode: "+688", minLength: 5, maxLength: 6 },
    { country: "Uganda", iso2: "UG", dialCode: "+256", minLength: 9, maxLength: 9 },
    { country: "Ukraine", iso2: "UA", dialCode: "+380", minLength: 9, maxLength: 9 },
    { country: "United Arab Emirates", iso2: "AE", dialCode: "+971", minLength: 8, maxLength: 9 },
    { country: "United Kingdom", iso2: "GB", dialCode: "+44", minLength: 10, maxLength: 10 },
    { country: "United States", iso2: "US", dialCode: "+1", minLength: 10, maxLength: 10 },
    { country: "Uruguay", iso2: "UY", dialCode: "+598", minLength: 7, maxLength: 8 },
    { country: "Uzbekistan", iso2: "UZ", dialCode: "+998", minLength: 9, maxLength: 9 },
    { country: "Vanuatu", iso2: "VU", dialCode: "+678", minLength: 5, maxLength: 7 },
    { country: "Vatican City (Holy See)", iso2: "VA", dialCode: "+379", minLength: 6, maxLength: 10 },
    { country: "Venezuela", iso2: "VE", dialCode: "+58", minLength: 10, maxLength: 10 },
    { country: "Vietnam", iso2: "VN", dialCode: "+84", minLength: 7, maxLength: 10 },
    { country: "Yemen", iso2: "YE", dialCode: "+967", minLength: 8, maxLength: 9 },
    { country: "Zambia", iso2: "ZM", dialCode: "+260", minLength: 9, maxLength: 9 },
    { country: "Zimbabwe", iso2: "ZW", dialCode: "+263", minLength: 5, maxLength: 9 },
];

export const useCountryCodes = () => {
    const getByCountry = (countryName) =>
        COUNTRY_CODES.find((c) => c.country === countryName) || null;

    const getByDialCode = (dialCode) =>
        COUNTRY_CODES.find((c) => c.dialCode === dialCode) || null;

    const isValidDialCode = (dialCode) =>
        COUNTRY_CODES.some((c) => c.dialCode === dialCode);

    // Returns { minLength, maxLength } for a country (by name) or dial code,
    // or null if not found.
    const getPhoneLengthRange = ({ country, dialCode } = {}) => {
        const entry = country ? getByCountry(country) : getByDialCode(dialCode);
        return entry ? { minLength: entry.minLength, maxLength: entry.maxLength } : null;
    };

    // Validates that a phone number (national significant number, digits only,
    // no dial code, no leading trunk zero) falls within the expected length
    // range for the given country name or dial code.
    // Example: isValidPhoneNumber({ country: "India" }, "9876543210") -> true
    // Example: isValidPhoneNumber({ country: "Germany" }, "15123456") -> true (8 digits, within 7-11)
    const isValidPhoneNumber = ({ country, dialCode } = {}, phoneNumber) => {
        const range = getPhoneLengthRange({ country, dialCode });
        if (!range) return false;
        const digitsOnly = String(phoneNumber).replace(/\D/g, "");
        return digitsOnly.length >= range.minLength && digitsOnly.length <= range.maxLength;
    };

    return {
        countryCodes: COUNTRY_CODES,
        getByCountry,
        getByDialCode,
        isValidDialCode,
        getPhoneLengthRange,
        isValidPhoneNumber,
    };
};